import {PreferencesHelper} from "@/helpers/PreferencesHelper";

export const INTERFACE_SETTINGS_PANEL = 7;

export const SETTINGS_TABS = [
    {index: 0, title: "settingsPage.name", icon: "home.svg", tone: "blue", keywords: "organisation org general contact adresse"},
    {index: 1, title: "settingsPage.orgaFlag", icon: "deviceIcon.svg", tone: "orange", keywords: "app application caisse compte"},
    {index: 2, title: "settingsPage.printerSettings", icon: "printer.svg", tone: "purple", keywords: "impression imprimante printer ticket afdrukken"},
    {index: 3, title: "Website", icon: "website.svg", tone: "green", keywords: "website webshop site web commande en ligne"},
    {index: 4, title: "settingsPage.vivaWallet", icon: "card.svg", tone: "pink", keywords: "viva wallet paiement terminal"},
    {index: 5, title: "Blackbox", icon: "box.svg", tone: "yellow", keywords: "blackbox fdm certifie"},
    {index: 6, title: "settingsPage.superSettings", icon: "terminal.svg", tone: "red", keywords: "super user su avance"},
    {index: 7, title: "preferencesPage.name", icon: "zap.svg", tone: "blue", keywords: "interface preference affichage"}
];

export function isSettingsTabAllowed(tab, user, isPhone) {
    const organisation = user?.organization || {};
    const isSuperUser = user?.type === "SUPER_USER";

    if (tab.index === 3) return !!organisation.onlineOrderWebPageEnabled;
    if (tab.index === 4) return organisation.partnerSource !== "MONNI";
    if (tab.index === 5) return process.env.VUE_APP_CERTIFIED === "true";
    if (tab.index === 6) return isSuperUser;
    if (tab.index === 7) return PreferencesHelper.visibleDefinitions(isPhone, isSuperUser).length > 0;

    return true;
}

export function allowedSettingsTabs(user, isPhone) {
    return SETTINGS_TABS.filter((tab) => isSettingsTabAllowed(tab, user, isPhone));
}
